var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import ProconNumberOfComplaintsSixMonths from '@/modules/search/components/filterPanels/ComplaintsPanel/ProconNumberOfComplaintsSixMonths.vue';
import { connect } from '@/overmind';
import { json } from 'overmind';
let ProconNumberOfComplaintsSixMonthsContainer = class ProconNumberOfComplaintsSixMonthsContainer extends Vue {
    constructor() {
        super(...arguments);
        // @ts-ignore
        this.values = json(this.inputValues);
    }
    onValuesChanged(newVal) {
        this.values = newVal;
        // @ts-ignore
        this.actionsSearch.searches.buildPotentialResults();
        // @ts-ignore
        this.setInputRangeProconComplaintsSixMonths(newVal);
    }
};
__decorate([
    Prop({ default: () => { } })
], ProconNumberOfComplaintsSixMonthsContainer.prototype, "filter", void 0);
ProconNumberOfComplaintsSixMonthsContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        selected: state.totalSelected.complaints.proconNumberOfComplaintsSixMonths,
        inputValues: state.selectedInputRange['reclamacoes_procon.quantidade_reclamacao_seis_meses'],
        setInputRangeProconComplaintsSixMonths: actions.filters.setInputRangeProconComplaintsSixMonths,
        actions: actions.filters,
        actionsSearch: actions.search,
    }), {
        components: { ProconNumberOfComplaintsSixMonths },
    }))
], ProconNumberOfComplaintsSixMonthsContainer);
export default ProconNumberOfComplaintsSixMonthsContainer;
